export const ShellRouteNames = {
  shell: "shell",
  externalShell: "external-shell",
};
